// client/src/hooks/useAgentSocket.js
import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

// En desarrollo el backend corre en localhost:5000; en producción el socket
// debe conectarse al mismo origen donde se sirve la app (no a localhost).
const SOCKET_BASE = process.env.NODE_ENV === 'production'
  ? window.location.origin
  : 'http://localhost:5000';

export function useAgentSocket(token, initialHandlers = {}) {
  const socketRef = useRef(null);

  // Objeto estable que expone las acciones Y los slots de handlers
  // (onNewMessage, onConversationAssigned, ...). Los componentes asignan sus
  // handlers sobre ESTE mismo objeto y los listeners del socket los leen aquí,
  // así siempre se invoca el handler actual sin recrear la conexión.
  const apiRef = useRef(null);
  if (!apiRef.current) {
    apiRef.current = {
      ...initialHandlers,
      sendMessage: (payload) => socketRef.current?.emit('send_message', payload),
      changeStatus: (status) => socketRef.current?.emit('status_change', { status }),
      transferConversation: (conversation_id, to_agent_id) =>
        socketRef.current?.emit('transfer', { conversation_id, to_agent_id }),
      transferToFlow: (conversation_id, flow_id) =>
        socketRef.current?.emit('transfer_to_flow', { conversation_id, flow_id }),
      closeConversation: (conversation_id, typification_id, notas) =>
        socketRef.current?.emit('close_conversation', { conversation_id, typification_id, notas }),
    };
  }

  useEffect(() => {
    if (!token) return;
    // Sin forzar 'websocket': Engine.IO arranca con polling (HTTP normal que el
    // proxy de producción ya enruta) y sube a WebSocket si está disponible.
    // Forzar websocket-only causa "handshake 400" detrás de proxies sin upgrade.
    const socket = io(`${SOCKET_BASE}/agent`, {
      auth: { token },
    });
    socketRef.current = socket;

    const api = apiRef.current;
    socket.on('new_message', (data) => api.onNewMessage?.(data));
    socket.on('conversation_assigned', (data) => api.onConversationAssigned?.(data));
    socket.on('conversation_removed', (data) => api.onConversationRemoved?.(data));
    socket.on('agent_status_changed', (data) => api.onAgentStatusChanged?.(data));

    return () => socket.disconnect();
  }, [token]);

  return apiRef.current;
}
